import { render, staticRenderFns } from "./PriceWidget.vue?vue&type=template&id=c1a7ac08&scoped=true"
import script from "./PriceWidget.vue?vue&type=script&lang=js"
export * from "./PriceWidget.vue?vue&type=script&lang=js"
import style0 from "./PriceWidget.vue?vue&type=style&index=0&id=c1a7ac08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a7ac08",
  null
  
)

export default component.exports